import React from 'react';

const truncate = (str, n) => {
    return str.length > n ? str.substr(0, n - 1) + '...' : str;
};

// Common BaseTooltip component
const BaseTooltip = ({
    children,
    title,
    placement = 'top',
    triangleColor = 'border-t-black',
    offsetLeft = null,
}) => {
    const isTop = placement === 'top';
    let tooltipStyle = {};
    if (offsetLeft) {
        tooltipStyle = {
            left: `calc(50% + ${offsetLeft}px)`,
            transform: 'translateX(-50%)',
        };
    }

    return (
        <div className="group relative text-sm">
            {children}
            <span
                style={tooltipStyle}
                className={`absolute ${isTop ? 'bottom-full mb-2' : 'top-full mt-2'} z-10 hidden rounded bg-white bg-opacity-100 p-2 opacity-100 shadow group-hover:block`}
            >
                {title}
                <span
                    className={`absolute ${isTop ? 'bottom-0' : 'top-0'} left-1/2 -translate-x-1/2 transform ${
                        isTop ? 'translate-y-full' : '-translate-y-full'
                    } h-0 w-0 border-l-4 border-r-4 ${
                        isTop
                            ? `border-t-4 ${triangleColor} border-b-0`
                            : `border-b-4 ${triangleColor} border-t-0`
                    } border-l-transparent border-r-transparent`}
                ></span>
            </span>
        </div>
    );
};

// Updated HGTooltip to pass offsetLeft
export const HGTooltip = ({ title, placement, offsetLeft }) => (
    <BaseTooltip title={title} placement={placement} offsetLeft={offsetLeft}>
        <div className="overflow-hidden text-ellipsis whitespace-nowrap font-light">
            {truncate(title, 38)}
        </div>
    </BaseTooltip>
);

// Updated LightTooltip to pass offsetLeft
export const LightTooltip = ({
    children,
    title,
    placement = 'top',
    offsetLeft,
}) => {
    if (!title) return children;
    return (
        <BaseTooltip
            title={title}
            placement={placement}
            triangleColor="border-t-black"
            offsetLeft={offsetLeft}
        >
            {children}
        </BaseTooltip>
    );
};

// ...existing code...

export default HGTooltip;
